// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");


  // const faq_toggal_wap = document.querySelector('[faq_main_wap]') || null; 
  // if(faq_toggal_wap){
  //  const faq_toggal = faq_toggal_wap.querySelectorAll('[data-act-title]') || null; 
  //   const collection_cust_content = faq_toggal_wap.querySelector('[faq_content_wap]') || null;
  //   const collection_cust_content_link = collection_cust_content.querySelectorAll('.tabs') || null;
  //   if(collection_cust_content){
  //    faq_toggal.forEach((faq) => {
  //       faq.addEventListener('click', (event) => {
  //         collection_cust_content_link.forEach((tabs) => {
  //           tabs.classList.remove('active');
  //           tabs.style.display = 'none';
  //         });
  //         faq_toggal.forEach((faq_active) => {
  //             faq_active.classList.remove('active-tab');
  //         });
  //           collection_cust_content.querySelector(event.currentTarget.getAttribute('data-act-title')).classList.add('active');
  //           collection_cust_content.querySelector(event.currentTarget.getAttribute('data-act-title')).style.display = 'block';
  //           event.currentTarget.classList.add('active-tab')
  //       });
  //     });
  //   }
  // }
  
})();

// accordions js end

//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end

// Menu Hover Start
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }
// Menu Hover end

// Product Card Heading Equal Height JS Start
// let maxHeight = 0;

// document.querySelectorAll(".pdp_img_blank .card .card__content .card__information .card__heading,.pdp_img_blank .card .card__content .card__information .custom_pdp_description p").forEach(div => {
//     if (div.offsetHeight > maxHeight) {
//         maxHeight = div.offsetHeight;
//     }
// });

// document.querySelectorAll(".pdp_img_blank .card .card__content .card__information .card__heading,.pdp_img_blank .card .card__content .card__information .custom_pdp_description p").forEach(div => {
//     div.style.height = maxHeight + "px";
// });
// Product Card Heading Equal Height JS End

//inquery popup
document.addEventListener("DOMContentLoaded", function () {
  const requestButton = document.querySelector(".request_button a");
  const requestForm = document.getElementById("request-form");
  const closeButton = document.querySelector(".close-request-form");
  
  requestButton.addEventListener("click", function (event) {
    event.preventDefault();
    requestForm.classList.add("active");
    document.body.classList.add("overflow-hidden");
    document.body.classList.add("request-popup-open");
  });

  closeButton.addEventListener("click", function () {
    requestForm.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("request-popup-open");
  });

  requestForm.addEventListener("click", function (event) {
    if (!event.target.closest(".request-form-inner")) {
      requestForm.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("request-popup-open");
    }
  });
});
